import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  LocationOfDevicesUnrelatedToRoadOccupationForm, LocationOfDevicesUnrelatedToRoadOccupationFormValue
} from '../../forms/location-of-devices-unrelated-to-road-occupation.form';
import { CommonModule, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import {
  LocationOfDevicesUnrelatedToRoadStageFormComponent
} from '../location-of-devices-unrelated-to-road-stage-form/location-of-devices-unrelated-to-road-stage-form.component';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    DatePickerComponent,
    TabViewComponent,
    TabPanelComponent,
    LocationOfDevicesUnrelatedToRoadStageFormComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-form.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationFormComponent {
  @Input()
  public edit: boolean = false;

  @Input()
  public showCancel: boolean = true;

  @Input()
  public form: LocationOfDevicesUnrelatedToRoadOccupationForm | undefined;

  @Output()
  public onSubmit = new EventEmitter<LocationOfDevicesUnrelatedToRoadOccupationFormValue>();

  @Output()
  public onCancel = new EventEmitter();

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.values);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset();
  }

}
